if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = ``;
      let content = this.innerHTML;
      let titleFlag = false;
      content = content.replace(/<\/p>|<\/div>/g, '');
      content = content.split('<p>');
      for ( let i = 1; i < content.length; i++ ) {
        let contentArray = content[i].split(/<br>|<br\/>|\n/g);

        contentDOM += `<div class="table">`

        if ( this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '' ) {
          if ( !titleFlag ) {
            titleFlag = true;
            contentDOM += `<span class="table-line table-line--heading">`;
            if ( this.dataset.titleLabelLeft != '' ) {
              contentDOM += `<span>${this.dataset.titleLabelLeft}</span>`;
            }
            if ( this.dataset.titleLabelRight != '' ) {
              contentDOM += `<span>${this.dataset.titleLabelRight}</span>`;
            }
            contentDOM += `</span>`;
          }
        }

        for ( let j = 0; j < contentArray.length; j++ ) {
          if (contentArray[j].length > 0 && contentArray[j].replace(/\s/g, '').length != 0 ) {
            // Two columns only for "label, value" lines: a short label before the first comma and a value that doesn't
            // carry on the sentence (no lowercase start). Prose such as "Older horses, sport horses and ..." stays one line.
            // Only a leading "-" marks an indented line; hyphens inside words (inside-out, fluorine-free) stay (Valerie 2026-11-01)
            let line = contentArray[j];
            let indent = /^\s*-/.test(line.replace(/<[^>]*>/g, ''));
            if ( indent ) line = line.replace('-', '');
            let comma = line.indexOf(',');
            let label = comma > -1 ? line.slice(0, comma) : line;
            let value = comma > -1 ? line.slice(comma + 1) : '';
            let labelText = label.replace(/<[^>]*>/g, '').trim();
            let valueText = value.replace(/<[^>]*>/g, '').trim();
            let split = comma > -1 && labelText.length > 0 && labelText.length <= 40 && valueText.length > 0 && !/^[a-zà-ÿ]/.test(valueText);
            let contentBlockArray = split ? [label, value] : [line];
            contentDOM += `<span class="table-line ${indent ? 'table-line--indent' : ''}${split ? '' : ' table-line--full'}">`;
            for ( let k = 0; k < contentBlockArray.length; k++ ) {
              if ( contentBlockArray[k].length > 0 && contentBlockArray[k].replace(/\s/g, '').length != 0 ) {
                contentDOM += `<span>${contentBlockArray[k]}</span>`
              }
            }
            contentDOM += `</span>`;
          }
        }

        contentDOM += `</div>`;

      }
      
      this.innerHTML = contentDOM;

    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}